var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGr = function SvgGr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v3.556H0V0z",
    fill: "#0061F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.556h48v3.556H0V3.556z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.11h48v3.557H0V7.11z",
    fill: "#0061F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.667h48v3.556H0v-3.556z",
    fill: "#FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.222h48v3.556H0v-3.556z",
    fill: "#0061F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.778h48v3.556H0v-3.556z",
    fill: "#FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.333h48v3.556H0v-3.557z",
    fill: "#0061F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.89h48v3.555H0V24.89z",
    fill: "#FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.444h48V32H0v-3.556zM0 0h17.778v17.778H0V0z",
    fill: "#0061F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11 0h3.557v17.778H7.11V0z",
    fill: "#FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.11h17.778v3.557H0V7.11z",
    fill: "#FFF"
  })));
};
export default SvgGr;